<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <h2 class="text-center">{{ currentUser.customUsername }} - Liste des personnages</h2>
      </div>
    </div>
    <hr>
    <div class="row">
        <div class="col-md-12">
          <table class="table table-striped">
              <thead>
                  <tr>
                      <th>Thème</th>
                      <th>Nom</th>
                      <th>Genre</th>
                      <th>Etat des enregistrements</th>
                      <th>Actions</th>
                  </tr>
              </thead>
              <tbody v-if="persons.length">
                  <tr v-for="person in persons" :key="person.id">
                      <td v-html="person.theme.name"></td>
                      <td v-html="person.name"></td>
                      <td>{{ person.gender == 'MALE' ? "Homme" : "Femme" }}</td>
                      <td class="text-center">{{ person.nbTexts.done + ' / ' + person.nbTexts.total + ' (' + (person.nbTexts.total - person.nbTexts.done) + ' restants)' }}</td>
                      <td>
                          <router-link tag="button" :disabled="!person.nbTexts.total" class="btn btn-info btn-sm" :to="{ name: 'UserRecord', params: { userId: currentUser.id, personId: person.id } }">Enregistrer voix</router-link>
                      </td>
                  </tr>
              </tbody>
              <tbody v-else>
              <tr>
                  <td>
                      Aucun personnage.
                  </td>
              </tr>
              </tbody>
          </table>
          <div class="pager"></div>
        </div>
    </div>
  </div>
</template>


<script>

    export default {
        components: {
        },
        computed: {
            currentUser: function() {
                return this.$store.state.user.currentUser;
            },
            persons: function() {
                return this.currentUser.persons;
            }
        },
        methods: {
        },
        data: function()  {
            return {
            };
        }
    };
</script>

<style>


</style>
